import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// AddCustomer component for creating new customer records
const AddCustomer = () => {
    const navigate = useNavigate();

    // Form state management
    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        city: "",
        note: "",
        familymembers: "",
        hearts: 0,
        isMember: false,
        swoppacketid: 0
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log('Checkbox change:', { name, type, checked }); // Debug log
        setFormData(prev => {
            const newState = {
                ...prev,
                [name]: type === 'checkbox' ? checked : value
            };
            console.log('New form state:', newState); // Debug log
            return newState;
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            const response = await fetch("/api/Customer", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.text();
                throw new Error(errorData || "Failed to add customer");
            }

            navigate("/");
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    // Validate required fields
    const isFormValid = () => {
        return (
            formData.firstname.trim() !== "" &&
            formData.lastname.trim() !== "" &&
            formData.email.trim() !== "" &&
            formData.city.trim() !== ""
        );
    };

    return (
        <div className="p-8 min-h-screen" style={{ background: 'linear-gradient(to bottom, #b3e672 10%, #7ba02d 90%)' }}>
            <div className="max-w-2xl mx-auto">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-2xl font-bold text-white">Add New Customer</h2>
                </div>

                {error && (
                    <div className="mb-4 p-4 bg-red-50 border-l-4 border-red-500 text-red-700">
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit} className="bg-white shadow-md rounded-lg p-6 space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {[
                            { label: "First Name *", name: "firstname", type: "text" },
                            { label: "Last Name *", name: "lastname", type: "text" },
                            { label: "Email *", name: "email", type: "email" },
                            { label: "City *", name: "city", type: "text" },
                        ].map((field, index) => (
                            <div key={index}>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    {field.label}
                                </label>
                                <input
                                    type={field.type}
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    required
                                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        ))}
                    </div>

                    {[
                        { label: "Family Members", name: "familymembers", type: "text" },
                        { label: "Note", name: "note", type: "textarea", rows: 3 },
                        { label: "Swop Packet ID", name: "swoppacketid", type: "number", min: 0 },
                        { label: "Hearts", name: "hearts", type: "number", min: "0" },
                    ].map((field, index) => (
                        <div key={index}>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {field.label}
                            </label>
                            {field.type === "textarea" ? (
                                <textarea
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    rows={field.rows}
                                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            ) : (
                                <input
                                    type={field.type}
                                    name={field.name}
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    min={field.min || undefined}
                                    className="block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            )}
                        </div>
                    ))}

                    {/* Member Checkbox */}
                    <div className="flex items-center">
                        <input
                            type="checkbox"
                            id="isMember"
                            name="isMember"
                            checked={formData.isMember}
                            onChange={handleChange}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <label htmlFor="isMember" className="ml-2 block text-sm text-gray-900">
                            Member
                        </label>
                    </div>

                    <div className="flex justify-end space-x-4 pt-4">
                        <button
                            type="button"
                            onClick={() => navigate("/")}
                            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={!isFormValid() || loading}
                            className={`px-4 py-2 text-sm font-medium text-white rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 
                                ${isFormValid() && !loading
                                    ? "bg-blue-500 hover:bg-blue-600"
                                    : "bg-blue-300 cursor-not-allowed"}`}
                        >
                            {loading ? "Adding..." : "Add Customer"}
                        </button>
                    </div>
                </form>

                <div className="mt-4 text-sm text-white">
                    * Required fields
                </div>
            </div>
        </div>
    );
};

export default AddCustomer;